import { render } from "./IconCalendar.vue?vue&type=template&id=7251f2a4&ts=true"
import script from "./IconCalendar.vue?vue&type=script&lang=ts"
export * from "./IconCalendar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__